import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { VERIFIED_AGENT_COUNT_DEFINITION } from "@/lib/verifiedAgentCountCopy";

interface VerifiedAgentCountLabelProps {
  label?: string;
}

/**
 * "Agents on Compaire" stat label with an info marker explaining what the
 * platform-derived count means. Rendered only when the org's verified count
 * is surfacing — the self-reported "Active Agents" label stays unmarked, see
 * verifiedAgentCountCopy.ts for why.
 */
export default function VerifiedAgentCountLabel({ label = "Agents on Compaire" }: VerifiedAgentCountLabelProps) {
  return (
    <span className="inline-flex items-center gap-1">
      {label}
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="What this count means"
            className="inline-flex text-ink-400 transition-colors hover:text-ink-600"
          >
            <Info className="h-3 w-3" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-[260px] text-xs">
          {VERIFIED_AGENT_COUNT_DEFINITION}
        </TooltipContent>
      </Tooltip>
    </span>
  );
}
